import * as React from 'react';
import { Context, useContext } from 'react';

export type LibraryComponentContextProps = {
  onUpdateLegacy?: (updateReferences: string[]) => void;
};

export const LibraryComponentContext: Context<LibraryComponentContextProps> =
  React.createContext({});

export const useLibraryComponentContext = (): LibraryComponentContextProps => {
  return useContext<LibraryComponentContextProps>(LibraryComponentContext);
};
